import { reorder, setTooltip } from "../../actions/filters";
import { LEFT, RIGHT, TARGET } from "../../constants/config/table";
import { CLASS_DRAGGABLE } from "../../constants/config/parameters";
import { IE11 } from "../../constants";
import React, { useEffect, useState, useRef } from "react";
import { useDispatch } from "react-redux";
import "./style.css";

const DragComponent = (props) => {
  let counter = 0;
  const dispatch = useDispatch();

  const [dragging, setDragging] = useState(false),
    format = IE11 ? "text" : "dropping",
    containerRef = useRef(null);

  useEffect(() => {
    if (!dragging && counter !== 0) counter = 0;
  });

  /**
   * @name determineSide
   * @function
   * @private
   * @param {number} pos Current cursor position
   * @returns {string}
   * @description Determines which side of a column, the drop target should appear on
   */
  const determineSide = (pos) => {
    if (props.immovable) return props.immovable;
    let coords = containerRef.current.getBoundingClientRect(),
      width = coords.width,
      half = width / 2,
      left = coords.left;
    return pos > left && pos < left + half ? RIGHT : LEFT;
  };

  /**
   * @name onDragStart
   * @function
   * @private
   * @description begins the drag transaction
   */
  const onDragStart = (e) => {
    let active = document.activeElement;

    if (
      !props.draggable ||
      (active && active.tagName === "INPUT" && e.target.contains(active)) ||
      (active &&
        active.tagName === "DIV" &&
        active.classList.contains("rc-slider-handle"))
    )
      return e.preventDefault();
    e.stopPropagation();
    e.dataTransfer.setData(format, props.id);
    setDragging(true);
    setTooltip(false);
  };

  /**
   * @name onDragEnd
   * @function
   * @private
   * @description Turn dragging off
   */
  const onDragEnd = (e) => setDragging(false);

  /**
   * @name onDragEnter
   * @function
   * @private
   * @description Handles when `<Paraneter />` is being dragged over
   */
  const onDragEnter = (e) => {
    let siblings = Array.from(containerRef.current.parentElement.children);
    siblings.forEach((element) => {
      if (element.dataset.parameter !== props.id) {
        element.classList.remove(TARGET, LEFT, RIGHT);
      }
    });

    counter++;

    if (e.dataTransfer.getData(format) === props.id) return;

    const SIDE = determineSide(e.screenX);
    console.log(e.screenX, "onDragEnter, determineSide", SIDE);
    switch (SIDE) {
      case LEFT:
        containerRef.current.classList.remove(RIGHT);
        break;
      default:
        containerRef.current.classList.remove(LEFT);
        break;
    }
    containerRef.current.classList.add(TARGET, SIDE); // add these in separate calls because IE11
  };

  /**
   * @name onDragLeave
   * @function
   * @private
   * @description removes classes
   */
  const onDragLeave = (e) => {
    counter--;
    if (counter === 0)
      containerRef.current.classList.remove(TARGET, LEFT, RIGHT);
  };

  /**
   * @name onDrop
   * @function
   * @private
   * @description Trigger the reorder once the user is done dragging
   */
  const onDrop = (e) => {
    counter = 0;
    containerRef.current.classList.remove(TARGET, LEFT, RIGHT);
    if (e.dataTransfer.getData(format) === props.id) return;
    const side = determineSide(e.screenX);
    console.log(e.screenX, "onDrop, determineSide DISPATCH", side);
    dispatch(reorder(e.dataTransfer.getData(format), props.id, side));
  };

  /**
   * @name onMouseEnter
   * @function
   * @description Sets the tooltip
   */
  const onMouseEnter = (e) => {
    e.stopPropagation();
    dispatch(
      setTooltip(containerRef.current.getBoundingClientRect(), props.tooltip)
    );
  };

  let classes = [""];

  if (props.className) classes.push(props.className);

  if (props.active) classes.push("active");

  if (props.minimized && !props.mobile) classes.push("minimized");

  if (props.draggable) classes.push(CLASS_DRAGGABLE);

  if (dragging) classes.push("dragging");

  if (IE11) classes.push("ie11");

  return (
    <div
      id={props.id}
      draggable={true}
      className={`drag-container ${classes.join(" ")}`}
      onDrop={onDrop}
      onDragOver={(e) => e.preventDefault()}
      onDragEnd={onDragEnd}
      onDragExit={onDragLeave}
      onDragLeave={onDragLeave}
      onDragEnter={onDragEnter}
      onDragStart={onDragStart}
      onMouseEnter={onMouseEnter}
      ref={containerRef}
    >
      {props.children}
    </div>
  );
};

export default DragComponent;
